//import '../common/setup-globals'; // not active currently for site.
import { manageSessions } from '../common/manageSessions';
//import { initGa } from '../common/analytics';

import './drag-scroll';

// Example of using expose-loader to expose a function to the global scope. However this exposed the entire analytics module, not just the function.
// so I moved this function to setup-globals.js instead
//import trackGoogleEvent from 'expose-loader?exposes=trackGoogleEvent!../common/analytics.js';

const sessionData = manageSessions();
//initGa(sessionData); // due to session issues I'm testing a variation where this is ported to the html page

// gam is already defined on the host page, but just in case it's not, define it here
var gam = gam || {};

/**
 * Walk up the DOM tree to find the first parent element with a class
 * Used to assign a name to the click event for GA
 * @param {Element} element - The starting element
 * @returns {string} Concatenated classnames or empty string if no parent has classes
 */
gam.getName = function(element) {
  let current = element.parentElement;
  while (current) {
    if (current.className) {
      return current.className;
    }
    current = current.parentElement;
  }
  return '';
}

/**
 * Track clicks on CTA links (https://c.gambinoslot.com/website_cta/*)
 * Uses event delegation on document to capture clicks before page redirect
 */
document.addEventListener('click', (e) => {
  const href = e.target?.href;
  if (href && href.startsWith('https://c.gambinoslot.com/website_cta/')) {

    // Send GA event for CTA click
    if (window.gtag) {
      window.gtag("event", "playnow_website_cta", {
        item_name: gam.getName(e.target)
      });
    }
  }
}, true); // Use capture phase to ensure it fires before navigation

